import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../node_modules/prop-types/index.js';
import React from 'react';

var NotificationEventLifecycle = /*#__PURE__*/function (_React$Component) {
  _inherits(NotificationEventLifecycle, _React$Component);

  var _super = _createSuper(NotificationEventLifecycle);

  function NotificationEventLifecycle() {
    var _this;

    _classCallCheck(this, NotificationEventLifecycle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "_timer", void 0);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;
      var _this$props$event = _this.props.event,
          creation = _this$props$event.creation,
          expiry = _this$props$event.expiry;

      if (expiry > 0) {
        var dismissal = creation + expiry - Date.now();

        if (dismissal > 0) {
          // set timer to automatically dismiss in the future
          _this._timer = setTimeout(_this.onDismiss, dismissal);
        } else {
          // already expired
          _this.onDismiss();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      clearTimeout(_this._timer);
      _this._isMounted = false;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (_this.props.dismiss && !prevProps.dismiss) {
        _this.onDismiss();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDismiss", function () {
      if (!_this.props.onDismiss || !_this._isMounted) return;

      _this.props.onDismiss();

      clearTimeout(_this._timer);
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return _this.props.children;
    });

    return _this;
  }

  return _createClass(NotificationEventLifecycle);
}(React.Component);

_defineProperty(NotificationEventLifecycle, "propTypes", {
  event: propTypes.object.isRequired,
  dismiss: propTypes.bool,
  onDismiss: propTypes.func,
  children: propTypes.node
});

var NotificationEventLifecycle$1 = NotificationEventLifecycle;

export { NotificationEventLifecycle$1 as default };
